module.exports = __webpack_public_path__ + "static/media/camel.5825618d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/camel.png
// module id = 628
// module chunks = 0